import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=145594fd&scoped=true&"
import script from "./BlogList.vue?vue&type=script&lang=ts&"
export * from "./BlogList.vue?vue&type=script&lang=ts&"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=145594fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145594fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VContainer,VDivider,VRow,VSubheader})
